<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  title: { type: String, required: true },
  showSearch: { type: Boolean, default: false },
  searchPlaceholder: { type: String, default: '' },
});
const search = defineModel('search', { type: String, default: '' });
</script>

<template>
  <!-- Matches ContactsHeader: 24px gutters, 20px medium title, 32px controls. -->
  <header class="sticky top-0 z-20 shrink-0 px-6 bg-n-surface-1">
    <div
      class="flex flex-wrap items-start sm:items-center justify-between w-full py-6 gap-4"
    >
      <h1 class="!m-0 text-xl font-medium truncate text-n-slate-12 min-w-0">
        {{ title }}
      </h1>
      <div class="flex flex-wrap items-center gap-4 max-w-full">
        <Input
          v-if="showSearch"
          v-model="search"
          type="search"
          :placeholder="searchPlaceholder"
          :custom-input-class="[
            'h-8 [&:not(.focus)]:!border-transparent bg-n-alpha-2 dark:bg-n-solid-1 ltr:!pl-8 !py-1 rtl:!pr-8',
          ]"
          class="w-56 max-w-full"
        >
          <template #prefix>
            <Icon
              icon="i-lucide-search"
              class="absolute -translate-y-1/2 text-n-slate-11 size-4 top-1/2 ltr:left-2 rtl:right-2"
            />
          </template>
        </Input>
        <div class="flex flex-wrap items-center gap-2">
          <slot />
        </div>
      </div>
    </div>
  </header>
</template>
